<template>

  <VUEModal v-if="PopupColoreSpessore" :Titolo="this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_IMP_COL_SPESS',this.LinguaUtente)" :Altezza="'115px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupColoreSpessore">
    <template v-slot:Body>

      <VUEColorPicker :Popup="PopupColorPicker" 
                       Programma="DMSEW" 
                      :Colore="OggettoPopupColoreSpessore.ColoreScelto" 
                      @OnClickConfermaPopup="ConfermaColore" 
                      @OnClickChiudiPopup="AnnullaColore">
      </VUEColorPicker>

      <div class="col-md-6" ref="DivBottoniPopupColoreSpessore">
        <button type="button" class="btn btn-info" style="float:right;margin-left:10px;font-weight:bold;width:80%" @click="PopupColorPicker = true" data-dismiss="modal">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_CAMBIA_COL',this.LinguaUtente) }}</button>
        
        <div style="clear:both;height:10px"></div>

        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_CAMBIA_SPESS',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="1" v-model="OggettoPopupColoreSpessore.Spessore">
          <!-- <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p> -->
        </div>
        <!-- <button type="button" class="btn btn-info" style="float:right;margin-left:10px;font-weight:bold;width:80%" data-dismiss="modal">Cambia spessore</button> -->
      </div>
      <div class="col-md-6">
        <VUEAnteprimaColoreSpessore :Colore="OggettoPopupColoreSpessore.Colore" 
                                    :Spessore="OggettoPopupColoreSpessore.Spessore"
                                    :Height="80"
                                    :Width ="200"
                                    :Istogramma="OggettoPopupColoreSpessore.Istogramma">
        </VUEAnteprimaColoreSpessore>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupColoreSpessore" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupColoreSpessore" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>


  <VUEModal v-if="PopupUdmX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)" :Altezza="'80px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="ObjGrafico.AxisX.UdmX"/>
        </div>

        <div style="">
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div style="">
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div style="">
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>
      </div> 
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjGrafico.AxisX.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>


  <VUEModal v-if="PopupMinMaxAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupImpostazioniAsseY">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="OggettoPopupMinMaxAsseY.Min">
          <!-- <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p> -->
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="OggettoPopupMinMaxAsseY.Max">
          <!-- <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaD
            iMisuraAsseY() }}</p> -->
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_IMP_ASSE_Y_UNITA',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="OggettoPopupMinMaxAsseY.Udm">
          <!-- <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ GetUnitaDiMisuraAsseY() }}</p> -->
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniAsseY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniAsseY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>


  <div style="min-height:500px; min-width:1200px">
    <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">       
      <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TITOLO1',this.LinguaUtente) }} - {{ GetDataFiltroPerLabel()}} - {{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TITOLO2',this.LinguaUtente) }} ({{OrientamentoAsse}}{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GRADI_NORD',this.LinguaUtente) }})</text>
    </div>
    <div style="width:83%;float:left" ref="DivCanvas">
      <VUEComponenteGraficoStazioneMeteo :WidthGrafico="GrandezzaCanvas.Width" 
                                         :HeightGrafico="GrandezzaCanvas.Height"
                                         :ListaModuli="ListaModuli"
                                         :DatiMeteo="DatiMeteo"
                                         :ObjDal="ObjDal"
                                         :ObjAl="ObjAl"
                                         :TipoGrafico="TipoGrafico"
                                         :PropsGrafico="ObjGrafico"
                                         :Repaint="Repaint"
                                         :UpdateAxes="UpdateAxes"
                                         :GraficiChange="GraficiChange"
                                         :ListaFalde="ListaFalde"
                                         :TempSuolo="TempSuolo"
                                         :OggettoTotaleSpostamento="OggettoTotaleSpostamento"/>
    </div>
      
    <div style="width:17%;float:left; border: solid 1px black;margin-top:24px" ref="DivButtons">
      <div style="margin-top:5px;">

        <div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
            </div> 
            <div style="float:left;width:95%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_TITOLO',this.LinguaUtente) }}</label>
            </div> 
            <div style="clear:both;height:12px"></div>
          </div>
          <div style="clear:both"></div>
        </div>

        <div style="float:left;width:2%;">&nbsp;</div>
        <div style="float:left;width:96%">
          <button type="button" class="btn btn-info" @click="OnClickUdmX" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente) }}</button>
        </div>
        <div style="float:left;width:2%;">&nbsp;</div>
        <div style="clear:both;height:20px"></div>

        <div v-if="MostraSpostamenti">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.Spostamenti)" class="form-control" v-model="ObjGrafico.Spostamenti.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_SPOST',this.LinguaUtente) }}</label>
            </div> 
            <div style="float:left;width:30%;" v-if="ObjGrafico.Spostamenti.Visualizza">
              
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.Spostamenti.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.Spostamenti)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.Spostamenti.Colore" 
                                            :Spessore="ObjGrafico.Spostamenti.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.Spostamenti)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.Spostamenti)"></i>
              </div>
            </div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>

        <div v-if="DatiMeteo != null && DatiMeteo.PresenzaVento">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input :disabled="!DatiMeteo.PresenzaVento" style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.Vento)" class="form-control" v-model="ObjGrafico.Vento.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_VENTO',this.LinguaUtente) }}</label>
            </div> 
            <div style="float:left;width:30%;" v-if="ObjGrafico.Vento.Visualizza">
              
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.Vento.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.Vento)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.Vento.Colore" 
                                            :Spessore="ObjGrafico.Vento.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.Vento)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.Vento)"></i>
              </div>
            </div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>

        <div v-if="DatiMeteo != null && DatiMeteo.PresenzaTemp">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input :disabled="!DatiMeteo.PresenzaTemp" style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.TemperaturaAria)" class="form-control" v-model="ObjGrafico.TemperaturaAria.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_TEMP_ARIA',this.LinguaUtente) }}</label>
            </div>
            <div style="float:left;width:30%;" v-if="ObjGrafico.TemperaturaAria.Visualizza">
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.TemperaturaAria.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.TemperaturaAria)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.TemperaturaAria.Colore" 
                                            :Spessore="ObjGrafico.TemperaturaAria.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.TemperaturaAria)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.TemperaturaAria)"></i>
              </div>
            </div> 
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>

        <div v-if="DatiMeteo != null && DatiMeteo.PresenzaPioggia">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input :disabled="!DatiMeteo.PresenzaPioggia" style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.CumulativoPioggia)" class="form-control" v-model="ObjGrafico.CumulativoPioggia.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_CUM_PIOGGIA',this.LinguaUtente) }}</label>
            </div> 
            <div style="float:left;width:30%;" v-if="ObjGrafico.CumulativoPioggia.Visualizza">
              
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.CumulativoPioggia.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.CumulativoPioggia)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.CumulativoPioggia.Colore" 
                                            :Spessore="ObjGrafico.CumulativoPioggia.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.CumulativoPioggia)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.CumulativoPioggia)"></i>
              </div>
            </div> 
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>

        <div v-if="ObjGrafico.CumulativoPioggia.Visualizza">
          <div style="float:left;width:15%;">&nbsp;</div>
          <div style="float:left;width:81%;">
            <div style="float:left;width:5%;">
              <input style="float:left;height:100%" type="checkbox" @change="Repaint++" class="form-control" v-model="ObjGrafico.CumulativoPioggia.ResetAssenzaDati"/>
            </div> 
            <div style="float:left;width:95%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_RESET',this.LinguaUtente) }}</label>
            </div> 
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>

        <div v-if="DatiMeteo != null && DatiMeteo.PresenzaPioggia">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.GiornalieroPioggia)" class="form-control" v-model="ObjGrafico.GiornalieroPioggia.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_GG_PIOGGIA',this.LinguaUtente) }}</label>
            </div> 
            <div style="float:left;width:30%;" v-if="ObjGrafico.GiornalieroPioggia.Visualizza">
              
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.GiornalieroPioggia.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.GiornalieroPioggia)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.GiornalieroPioggia.Colore" 
                                            :Spessore="ObjGrafico.GiornalieroPioggia.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            :Istogramma="true"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.GiornalieroPioggia)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.GiornalieroPioggia)"></i>
              </div></div> 
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>

        <div v-if="DatiMeteo != null && DatiMeteo.PresenzaPioggia">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.PrecipitazioneOraria)" class="form-control" v-model="ObjGrafico.PrecipitazioneOraria.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_PREC_ORARIA',this.LinguaUtente) }}</label>
            </div> 
            <div style="float:left;width:30%;" v-if="ObjGrafico.PrecipitazioneOraria.Visualizza">
              
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.PrecipitazioneOraria.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.PrecipitazioneOraria)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.PrecipitazioneOraria.Colore" 
                                            :Spessore="ObjGrafico.PrecipitazioneOraria.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            :Istogramma="true"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.PrecipitazioneOraria)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.PrecipitazioneOraria)"></i>
              </div>
            </div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>


        <div v-if="Visualizza10MinutiPioggia() && DatiMeteo != null && DatiMeteo.PresenzaPioggia">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;">
              <input style="float:left;height:100%" type="checkbox" @change="OnChangeCheck(ObjGrafico.DieciMinutiPioggia)" class="form-control" v-model="ObjGrafico.DieciMinutiPioggia.Visualizza"/>
            </div> 
            <div style="float:left;width:65%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_10M_PIOGGIA',this.LinguaUtente) }}</label>
            </div> 
            <div style="float:left;width:30%;" v-if="ObjGrafico.DieciMinutiPioggia.Visualizza">
              
              <!-- <div style="float:left;width:1%;">&nbsp;</div>
              <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.DieciMinutiPioggia.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.DieciMinutiPioggia)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.DieciMinutiPioggia.Colore" 
                                            :Spessore="ObjGrafico.DieciMinutiPioggia.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            :Istogramma="true"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.DieciMinutiPioggia)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.DieciMinutiPioggia)"></i>
              </div>
            </div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          
          <div style="clear:both;height:10px"></div>
        </div>


        <div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            
            <div style="float:left;width:5%;"></div> 
            <div style="float:left;width:95%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_FALDA',this.LinguaUtente) }}</label>
            </div>
            <div style="clear:both;height:1px"></div>
            

            <div style="float:left;width:68%;">
              <select class="form-control" v-model="ObjGrafico.Falda.Modulo" @change="OnChangeFalda">
                <option :value="null">-</option> 
                <option v-for="Falda in ListaFalde" 
                        :Key="Falda.Id"
                        :value="Falda.Id">{{ this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) }} {{Falda.Id}}</option>  
              </select>
            </div> 
            <div style="float:left;width:1%;">&nbsp;</div>
            <div style="float:left;width:30%;margin-top:8px" v-if="ObjGrafico.Falda.Modulo != null">
              
              <!-- <div style="float:left;width:1%;">&nbsp;</div>
              <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.Falda.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.Falda)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.Falda.Colore" 
                                            :Spessore="ObjGrafico.Falda.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.Falda)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:right;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.Falda)"></i>
              </div>
            </div>
            <div style="clear:both;height:3px"></div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="clear:both;height:10px"></div>
        </div>


        <div v-if="TempSuolo != null">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">

            <div style="float:left;width:5%;"></div> 
            <div style="float:left;width:95%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_TEMP_SUOLO',this.LinguaUtente) }}</label>
            </div>
            <div style="clear:both;height:1px"></div>


            <div style="float:left;width:68%;">
              <select class="form-control" v-model="ObjGrafico.TemperaturaAlSuolo.Modulo" @change="OnChangeTemperaturaSuolo">
                <option :value="null">-</option> 
                <option v-for="Sensore in TempSuolo.Sensori" 
                        :Key="Sensore.Id"
                        :value="Sensore.Id">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_TEMP_SUOLO_MOD',this.LinguaUtente) }} {{Sensore.Id}}</option>  
              </select>
            </div> 
            <div style="float:left;width:1%;">&nbsp;</div>
            <div style="float:left;width:30%;margin-top:8px" v-if="ObjGrafico.TemperaturaAlSuolo.Modulo != null">
              
              <!-- <div style="float:left;width:1%;">&nbsp;</div> -->
              <!-- <div style="float:left;width:32%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-pencil" :style="{ color : ObjGrafico.TemperaturaAlSuolo.Colore }" @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.TemperaturaAlSuolo)"></i>
              </div> -->
              <div style="float:right;width:32%;">
                <VUEAnteprimaColoreSpessore :Colore="ObjGrafico.TemperaturaAlSuolo.Colore" 
                                            :Spessore="ObjGrafico.TemperaturaAlSuolo.Spessore"
                                            :Height="20"
                                            :Width="35"
                                            @click="OnClickVisualizzaPopupColoreSpessore(ObjGrafico.TemperaturaAlSuolo)"
                                            style="cursor:pointer">
                </VUEAnteprimaColoreSpessore>
              </div>
              <div style="float:left;width:1%;">&nbsp;</div>
              <div style="float:right;width:34%;">
                <i style="font-size:20px;cursor:pointer" class="fa fa-bar-chart-o" @click="OnClickVisualizzaPopupMinMaxAsseY(ObjGrafico.TemperaturaAlSuolo)"></i>
              </div></div>
            <div style="clear:both;height:3px"></div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="clear:both;height:10px"></div>
        </div>


        <div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
            <div style="float:left;width:5%;"></div> 
            <div style="float:left;width:95%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TAB_ASSE_PRINC',this.LinguaUtente) }}</label>
            </div>
            <div style="clear:both;height:1px"></div>
            <div style="float:left;width:100%;">
              <select class="form-control" v-model="ObjGrafico.AssePrincipale" @change="Repaint++">
                <!-- <option :value="null">-</option>  -->
                <option v-for="Asse in ListaAssi" 
                        :Key="Asse.Id"
                        :value="Asse.Id">{{Asse.LabelGrafica}}</option>  
              </select>
            </div> 
            <div style="clear:both;height:3px"></div>
          </div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="clear:both;height:10px"></div>
        </div>

        <div style="float:left;width:2%;">&nbsp;</div>
        <div style="float:left;width:96%">
          <button type="button" class="btn btn-info" style="width:100%" @click="EsportaComePDF()">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
        </div>
        <div style="float:left;width:2%;">&nbsp;</div>
        <div style="clear:both;height:4px"></div>


      </div>   
      <div style="float:left;">&nbsp;</div>
    </div>
  </div>
  <div style="clear:both"></div>

</template>

<script>
import { COLORI_PANTONE, 
         SystemInformation, 
         TIPOLOGIA_GRAFICI_STORICI, 
         SPESSORE_LINEE_GRAFICI,  
         TIPI_UDM_X,
         TIPI_GRAFICI_STAZIONE_METEO
       } from '@/SystemInformation'
import VUEComponenteGraficoStazioneMeteo from './VUEComponenteGraficoStazioneMeteo.vue'
import { TZDateFunct, MS_X_DAY } from '@/utils/ZDateFunct.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import VUEModal from '@/utils/VUEModal.vue'
import VUEAnteprimaColoreSpessore from '../Multi/VUEAnteprimaColoreSpessore.vue'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            ColoriPantone    : COLORI_PANTONE,
            OrientamentoAsse : SystemInformation.OggettoInfoGraficiStorici.OrientamentoAsse,
            GrandezzaCanvas  : {
                                  Width  : 0,
                                  Height : 0
                               },
            TipiUdmX         : TIPI_UDM_X,

            OggettoPopupMinMaxAsseY : null,
            OggettoDatiPerAnnulla   : {
                                        Min : 0,
                                        Max : 0,
                                        Udm : 0,
                                      },
            PopupMinMaxAsseY        : false,

            OggettoPopupColoreSpessore : null,
            PopupColoreSpessore        : false,
            MostraSpostamenti          : true,
            MostraDieciMinutiPioggia   : false,
            MostraSempreDieciMinutiPioggia : true,
            LinguaUtente               : SystemInformation.UserInformation.Lingua,

            ObjGrafico       : {
                                  AxisX                : {
                                                            TipoUdmX   : TIPI_UDM_X.Giorni, 
                                                            UdmX       : 1, 
                                                            Modificato : false, 
                                                         },
                                  AxisY                : {
                                                            Min : 0,
                                                            Max : 0,
                                                            Udm : 0,
                                                            
                                                            Modificato : false,
                                                         },
                                  Spostamenti          : {
                                                            Min          : -3,
                                                            Max          : 3,
                                                            Udm          : 1,
                                                            Spessore     : SPESSORE_LINEE_GRAFICI,
                                                            Colore       : '#ff0000',
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_SPOST_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.Spostamenti,
                                                            Modificato   : false,
                                                         },
                                  Vento                : {
                                                            Min          : 2,
                                                            Max          : 2,
                                                            Udm          : 2,
                                                            Spessore     : 0,
                                                            Colore       : '#9c3b3b', //'#ffa500',
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_VENTO',SystemInformation.UserInformation.Lingua),
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_VENTO_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.Vento,
                                                            Modificato   : false,
                                                         },
                                  TemperaturaAria      : {
                                                            Min          : -10,
                                                            Max          : 10,
                                                            Udm          : 1,
                                                            Spessore     : 0,
                                                            Colore       : '#ff0000', //'#ffa500',
                                                            Visualizza   : false,
                                                            Label        : '  ',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TEMP_ARIA_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.TemperaturaAria,
                                                            Modificato   : false,
                                                         },
                                  CumulativoPioggia    : {
                                                            Min          : 0,
                                                            Max          : 10,
                                                            Udm          : 1,
                                                            Spessore     : SPESSORE_LINEE_GRAFICI,
                                                            Colore       : '#0000a1', //'#000080',
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_CUM',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_CUM_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.CumulativoPioggia,
                                                            Modificato   : false,
                                                        
                                                            ResetAssenzaDati : true,
                                                         },
                                  GiornalieroPioggia   : {
                                                            Min          : 0,
                                                            Max          : 10,
                                                            Udm          : 1,
                                                            Spessore     : 0,  
                                                            Colore       : '#0080ff', //'#c2e4ff',
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_GG',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PIOGGIA_GG_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.GiornalieroPioggia,
                                                            Modificato   : false,
                                                         },
                                  PrecipitazioneOraria : {
                                                            Min          : 0,
                                                            Max          : 10,
                                                            Udm          : 1,
                                                            Spessore     : 0,
                                                            Colore       : '#80ffff', //'#0000ff',
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PREC_ORARIA',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_PREC_ORARIA_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.PrecipitazioneOraria,
                                                            Modificato   : false,
                                                         },
                                  DieciMinutiPioggia   : {
                                                            Min          : 0,
                                                            Max          : 30,
                                                            Udm          : 5,
                                                            Spessore     : 0,
                                                            Colore       : '#0000ff',
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_10_MIN',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_10_MIN_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.DieciMinutiPioggia,
                                                            Modificato   : false,
                                                         },
                                  Falda                : {
                                                            Min          : -10,
                                                            Max          : 10,
                                                            Udm          : 1,
                                                            Spessore     : 0,
                                                            Colore       : '#0000ff',
                                                            Modulo       : null,
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_FALDA',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_FALDA_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.Falda,
                                                            Modificato   : false,
                                                         },
                                  TemperaturaAlSuolo   : {
                                                            Min          : -10,
                                                            Max          : 10,
                                                            Udm          : 1,
                                                            Spessore     : 0,
                                                            Colore       : '#ff8040', //'#ff0000',
                                                            Modulo       : null,
                                                            DatiModulo   : [],
                                                            Visualizza   : false,
                                                            Label        : this.GetTraduzioneLabel('VUEComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TEMP_SUOLO',SystemInformation.UserInformation.Lingua) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',SystemInformation.UserInformation.Lingua) + ']',
                                                            LabelGrafica : this.GetTraduzioneLabel('VUEFrameComponenteGraficoStazioneMeteo','TKN_GRAF_STAZ_METEO_TEMP_SUOLO_MENU',SystemInformation.UserInformation.Lingua),
                                                            Id           : TIPI_GRAFICI_STAZIONE_METEO.TemperaturaSuolo,
                                                            Modificato   : false,
                                                         },

                                  AssePrincipale       : null,
                                },
            Repaint          : 0,
            UpdateAxes       : 0,
            TipologieGrafici : TIPOLOGIA_GRAFICI_STORICI,
            FaldaSelezionata : null,
            PopupUdmX        : false,
            PopupColorPicker : false,
          }
  },

  props : [
            'ListaModuli', 
            'ObjDal', 
            'ObjAl', 
            'TipoGrafico', 
            'GraficiChange', 
            'ListaFalde',
            'DatiMeteo',
            'TempSuolo',
            'OggettoTotaleSpostamento',
            'ParametriPDF',
            'GetDatiPDF',
            'DalRicerca',
            'AlRicerca'
          ],

  emits : ['EsportaPDFGrafico'],

  components: { 
                VUEComponenteGraficoStazioneMeteo,
                VUEModal,
                VUEAnteprimaColoreSpessore,
                VUEColorPicker,
              },

  methods :
  {
    EsportaComePDF()
    {
      let IdModulo = -1
      this.$emit('EsportaPDFGrafico', IdModulo)
    },

    GetGraficiPDF()
    {
      let ListaAssi = []
      // IL GRAFICO NON è RELATIVO AL SINGOLO MODULO, QUINDI LA GESTIONE ATTUALE NON VA BENE 
      for (let k in this.ObjGrafico)
      {
        let Asse = this.ObjGrafico[k]
        if (Asse && Asse.Visualizza)
        {
          let ObjAsse = {Id: Asse.Id, Colore: Asse.Colore, Min: Asse.Min, Max: Asse.Max, Udm: Asse.Udm, LabelGrafica: Asse.LabelGrafica, Principale: Asse.Id == this.ObjGrafico.AssePrincipale}
          if (Asse.Modulo != null && Asse.Modulo != undefined)
            ObjAsse.Modulo = Asse.Modulo
          ListaAssi.push(ObjAsse)
        }
      }

      let ModuliConsiderati = []

      for (let i = 0; i < this.ListaModuli.length; i++)
      {
        let SingleModulo = this.ListaModuli[i]
        let ObjModulo = {Id : SingleModulo.Id, Profondita : SingleModulo.Profondita, Orientamento : SingleModulo.Orientamento}
        ModuliConsiderati.push(ObjModulo)
      }
      
      ModuliConsiderati.DettagliGrafico = TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico)
      ModuliConsiderati.AltriAssi = ListaAssi

      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []
      
      this.ObjPDF.PDFModulo.push(ModuliConsiderati)
      this.ObjPDF.PDFObjDatiGrafici.push(TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico))

    },

    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = 540
    },

    GetDataFiltroPerLabel()
    {
      let Result = ''
      Result += this.GetTraduzioneLabel('Generic','TKN_DAL',this.LinguaUtente) + ' ' + TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(this.DalRicerca.Data))
      Result += ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) + '  ' + this.DalRicerca.Ora
      Result += ' ' + this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) + ' ' + TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(this.AlRicerca.Data))
      Result += ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) + '  ' + this.AlRicerca.Ora

      return Result
    },

    OnChangeCumulativoPioggia()
    {
      // if(!this.ObjGrafico.CumulativoPioggia.Visualizza)
      //   this.ObjGrafico.CumulativoPioggia.ResetAssenzaDati = false
      this.Repaint++
    },

    OnClickUdmX()
    {
      this.PopupUdmX = true
    },
    ConfermaPopupUdmX()
    {
      this.ObjGrafico.AxisX.Modificato = true
      this.Repaint++
      this.PopupUdmX = false
    },
    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false
    },


    OnClickVisualizzaPopupMinMaxAsseY(Asse)
    {
      this.OggettoPopupMinMaxAsseY   = null
      this.OggettoPopupMinMaxAsseY   = Asse

      this.OggettoDatiPerAnnulla.Min = Asse.Min 
      this.OggettoDatiPerAnnulla.Max = Asse.Max 
      this.OggettoDatiPerAnnulla.Udm = Asse.Udm 
      
      Asse.Modificato = true

      this.PopupMinMaxAsseY          = true
    },
    AnnullaPopupImpostazioniAsseY()
    {
      this.OggettoPopupMinMaxAsseY.Min = this.OggettoDatiPerAnnulla.Min
      this.OggettoPopupMinMaxAsseY.Max = this.OggettoDatiPerAnnulla.Max
      this.OggettoPopupMinMaxAsseY.Udm = this.OggettoDatiPerAnnulla.Udm

      this.OggettoPopupMinMaxAsseY     = null;
      
      this.PopupMinMaxAsseY            = false
    },
    ConfermaPopupImpostazioniAsseY()
    {
      this.OggettoPopupMinMaxAsseY     = null;
      this.PopupMinMaxAsseY            = false
      this.UpdateAxes++
    },


    OnClickVisualizzaPopupColoreSpessore(DatiColoreSpessore)
    {
      this.OggettoPopupColoreSpessore          = {}
      
      this.OggettoPopupColoreSpessore.Colore      = DatiColoreSpessore.Colore 
      this.OggettoPopupColoreSpessore.Spessore    = DatiColoreSpessore.Spessore 
      this.OggettoPopupColoreSpessore.Selezionato = DatiColoreSpessore 

      this.OggettoPopupColoreSpessore.ColoreScelto = {}
      this.OggettoPopupColoreSpessore.ColoreScelto.Colore           = DatiColoreSpessore.Colore
      this.OggettoPopupColoreSpessore.ColoreScelto.ColorePerAnnulla = DatiColoreSpessore.Colore

      this.PopupColoreSpessore            = true
    },
    AnnullaPopupColoreSpessore()
    {
      this.OggettoPopupColoreSpessore     = null;
      this.PopupColoreSpessore            = false
    },
    ConfermaPopupColoreSpessore()
    {
      this.OggettoPopupColoreSpessore.Selezionato.Colore   = this.OggettoPopupColoreSpessore.Colore  
      this.OggettoPopupColoreSpessore.Selezionato.Spessore = this.OggettoPopupColoreSpessore.Spessore

      this.OggettoPopupColoreSpessore     = null;
      this.PopupColoreSpessore            = false
      this.Repaint++
    },


    ConfermaColore()
    {
      this.OggettoPopupColoreSpessore.Colore = this.OggettoPopupColoreSpessore.ColoreScelto.Colore
      this.PopupColorPicker                  = false
    },
    AnnullaColore()
    {
      this.OggettoPopupColoreSpessore.Colore = this.OggettoPopupColoreSpessore.ColoreScelto.ColorePerAnnulla
      this.PopupColorPicker                  = false
    },


    OnChangeCheck(TipoCheckClicked)
    {
      if(TipoCheckClicked.Visualizza)
      {
        if(this.ObjGrafico.AssePrincipale == null)
          this.ObjGrafico.AssePrincipale = TipoCheckClicked.Id
      }
      else 
      {
        if(this.ObjGrafico.AssePrincipale == TipoCheckClicked.Id)
        {
          if(this.ListaAssi.length != 0)
          {
            this.ObjGrafico.AssePrincipale = this.ListaAssi[0].Id
          }
          else
          {
            this.ObjGrafico.AssePrincipale = null            
          }
        }
      }
      this.Repaint++
    },

    OnChangeFalda()
    {
      if(this.ObjGrafico.Falda.Modulo != null)
        this.ObjGrafico.Falda.Visualizza = true
      else this.ObjGrafico.Falda.Visualizza = false

      if(this.ObjGrafico.Falda.Visualizza)
      {
        if(this.ObjGrafico.AssePrincipale == null)
          this.ObjGrafico.AssePrincipale = this.ObjGrafico.Falda.Id
        this.Repaint++
      }
      else 
      {
        if(this.ObjGrafico.AssePrincipale == this.ObjGrafico.Falda.Id)
        {
          if(this.ListaAssi.length != 0)
            this.ObjGrafico.AssePrincipale = this.ListaAssi[0].Id
          else this.ObjGrafico.AssePrincipale = null
        }
        this.Repaint++
      }
    },

    OnChangeTemperaturaSuolo()
    {
      if(this.ObjGrafico.TemperaturaAlSuolo.Modulo != null)
      {
        this.ObjGrafico.TemperaturaAlSuolo.Visualizza = true
        this.ObjGrafico.TemperaturaAlSuolo.DatiModulo = this.GetDatiModuloTempSuolo(this.ObjGrafico.TemperaturaAlSuolo.Modulo)
      }
      else 
      {
        this.ObjGrafico.TemperaturaAlSuolo.DatiModulo = []
        this.ObjGrafico.TemperaturaAlSuolo.Visualizza = false
      }

      if(this.ObjGrafico.TemperaturaAlSuolo.Visualizza)
      {
        if(this.ObjGrafico.AssePrincipale == null)
          this.ObjGrafico.AssePrincipale = this.ObjGrafico.TemperaturaAlSuolo.Id
      }
      else 
      {
        if(this.ObjGrafico.AssePrincipale == this.ObjGrafico.TemperaturaAlSuolo.Id)
        {
          if(this.ListaAssi.length != 0)
            this.ObjGrafico.AssePrincipale = this.ListaAssi[0].Id
          else this.ObjGrafico.AssePrincipale = null
        }
      }
      this.Repaint++
    },

    GetDatiModuloTempSuolo(Id)
    {
      if(this.TempSuolo != null)
        for(let i = 0; i < this.TempSuolo.Sensori.length; i++)
          if(this.TempSuolo.Sensori[i].Id == Id)
            return this.TempSuolo.Sensori[i].Dati
    },

    GeneraOggettoGrafico(Dati)
    {
      let OggettoGrafico          = {}
      OggettoGrafico.Id           = Dati.Id
      OggettoGrafico.LabelGrafica = Dati.LabelGrafica
      if(this.ObjGrafico.AssePrincipale == null)
        this.ObjGrafico.AssePrincipale = Dati.Id
      return OggettoGrafico
    },

    Visualizza10MinutiPioggia()
    {
      let Dalle = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10 ? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      let Alle  = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10 ? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      if(Math.abs(Dalle - Alle) <= 2 * MS_X_DAY || this.MostraDieciMinutiPioggia)
        return true
      return false
    },

  },
  
  computed:
  {
    CurrentListaModuli :
    {
      get()
      {
        return this.ListaModuli
      }
    },

    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    },

    ListaAssi :
    {
      get()
      { 
        let Result = []
        if(this.ObjGrafico.Spostamenti.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.Spostamenti))

        if(this.ObjGrafico.Vento.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.Vento))

        if(this.ObjGrafico.TemperaturaAria.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.TemperaturaAria))

        if(this.ObjGrafico.CumulativoPioggia.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.CumulativoPioggia))
        
        if(this.ObjGrafico.GiornalieroPioggia.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.GiornalieroPioggia))
        
        if(this.ObjGrafico.PrecipitazioneOraria.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.PrecipitazioneOraria))
        
        if(this.ObjGrafico.DieciMinutiPioggia.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.DieciMinutiPioggia))
        
        if(this.ObjGrafico.Falda.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.Falda))

        if(this.ObjGrafico.TemperaturaAlSuolo.Visualizza)
          Result.push(this.GeneraOggettoGrafico(this.ObjGrafico.TemperaturaAlSuolo))

        return Result
      }
    },
  },

  watch:
  {
    GetDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    }
  },

  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
  },
  beforeMount()
  {    
    let IsSpostamentiPresente = SystemInformation.OggettoInfoGraficiStorici.VisualizzaSpostamento
    if (IsSpostamentiPresente)
    {
      this.ObjGrafico.Spostamenti.Visualizza = true 
      this.MostraSpostamenti = true
    }
    else
    {
      this.ObjGrafico.Spostamenti.Visualizza = false 
      this.MostraSpostamenti = false
    }
    if(this.OggettoTotaleSpostamento != null && this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length > 0)
    {
      this.ObjGrafico.Spostamenti.Min        = this.OggettoTotaleSpostamento.MinAdattamentoAsseYSpost
      this.ObjGrafico.Spostamenti.Max        = this.OggettoTotaleSpostamento.MaxAdattamentoAsseYSpost
      this.ObjGrafico.Spostamenti.Udm        = this.OggettoTotaleSpostamento.UdmYSpost
    }

    if(this.DatiMeteo != null && this.DatiMeteo.PresenzaPioggia)
    {
      this.ObjGrafico.CumulativoPioggia.Visualizza    = true
      this.ObjGrafico.GiornalieroPioggia.Visualizza   = true
      this.ObjGrafico.PrecipitazioneOraria.Visualizza = true
    }

    if(this.MostraSempreDieciMinutiPioggia)
    {
      this.ObjGrafico.DieciMinutiPioggia.Visualizza = true
      this.MostraDieciMinutiPioggia = true 
    }
  }
}
</script>